<template>
    <div class="columns">
        <div class="column">
            <div class="content">
                <h2 class="title">GW2Scratch.EVTCAnalytics</h2>
                <p>
                    A .NET library for parsing and analyzing EVTC logs. Built with integration in other projects
                    in mind. Currently has a very unstable API, changes are to be expected.
                </p>
                <h3>Features</h3>
                <ul>
                    <li>Get raw agent, skill and combat item data from logs</li>
                    <li>Get agents and processed events with structured data</li>
                    <li>Get encounter results</li>
                    <li>Calculate statistics such a DPS, buff uptimes and similar (very work-in-progress)</li>
                </ul>
                <p>
                    For more details, see <a
                        href="https://github.com/gw2scratch/evtc/tree/master/EVTCAnalytics">the README</a>.
                </p>
            </div>
        </div>
        <div class="column is-4">
            <ProgramDownloads release-feed-url="/releases/analytics.json" program-name="GW2Scratch.EVTCAnalytics" />
        </div>
    </div>
</template>

<script>
    import ProgramDownloads from "@/components/ProgramDownloads";

    export default {
        name: 'tools-library',
        components: {ProgramDownloads},
    }
</script>

<style>
</style>
